export const opsBasePath = "/ops";

export const opsTabs = [
  { key: "tasks", label: "Tasks" },
  { key: "due-diligence", label: "Due Diligence" },
  { key: "inbox", label: "Inbox" },
  { key: "reviews", label: "Second opinions" },
  { key: "library", label: "Reference library" },
  { key: "settings", label: "Settings" },
] as const;

export type OpsTab = (typeof opsTabs)[number]["key"];

export const defaultOpsTab: OpsTab = "inbox";

type OpsSearchParams = {
  query?: string | null;
  itemId?: string | null;
};

export function isOpsTab(value: string | undefined): value is OpsTab {
  return opsTabs.some((tab) => tab.key === value);
}

// Relative to the Ops router, which is based at `opsBasePath`.
export function buildOpsHref(tab: OpsTab, params: OpsSearchParams = {}) {
  const search = buildOpsSearchParams(params).toString();

  if (!search) {
    return `/${tab}`;
  }

  return `/${tab}?${search}`;
}

export function buildOpsSearchParams({ query, itemId }: OpsSearchParams) {
  const params = new URLSearchParams();

  if (query) {
    params.set("q", query);
  }

  if (itemId) {
    params.set("item", itemId);
  }

  return params;
}
